import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import matchAll from 'string.prototype.matchall';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _wrapRegExp(re, groups) {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, groups);
  };

  var _RegExp = _wrapNativeSuper(RegExp);

  var _super = RegExp.prototype;

  var _groups = new WeakMap();

  function BabelRegExp(re, groups) {
    var _this = _RegExp.call(this, re);

    _groups.set(_this, groups);

    return _this;
  }

  _inherits(BabelRegExp, _RegExp);

  BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    if (result) result.groups = buildGroups(result, this);
    return result;
  };

  BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if (typeof substitution === "string") {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    } else if (typeof substitution === "function") {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = [];
        args.push.apply(args, arguments);

        if (typeof args[args.length - 1] !== "object") {
          args.push(buildGroups(args, _this));
        }

        return substitution.apply(this, args);
      });
    } else {
      return _super[Symbol.replace].call(this, str, substitution);
    }
  };

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      groups[name] = result[g[name]];
      return groups;
    }, Object.create(null));
  }

  return _wrapRegExp.apply(this, arguments);
}

var reduceTargetKeys = function reduceTargetKeys(target, keys, predicate) {
  return Object.keys(target).reduce(predicate, {});
};

var omit = function omit() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return reduceTargetKeys(target, keys, function (acc, key) {
    return keys.some(function (omitKey) {
      return omitKey === key;
    }) ? acc : _objectSpread2({}, acc, _defineProperty({}, key, target[key]));
  });
};
var isFunction = function isFunction(fn) {
  return Object.prototype.toString.call(fn) === '[object Function]';
};
var isNumber = function isNumber(n) {
  return Object.prototype.toString.call(n) === '[object Number]';
};

(function trimStartPolyfill(w) {
  var _this = this;

  var String = w.String;

  (function (_ref) {
    var proto = _ref.prototype;

    // eslint-disable-next-line no-param-reassign
    proto.trimStart = proto.trimStart || proto.trimLeft || function () {
      return _this.replace(/^\s+/, '');
    };
  })(String);
})(window);

matchAll.shim();
var propTypes = {
  autoFocus: PropTypes.bool,
  component: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maskDelay: PropTypes.number,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

var DurationInputMask =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DurationInputMask, _PureComponent);

  function DurationInputMask(props) {
    var _this;

    _classCallCheck(this, DurationInputMask);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DurationInputMask).call(this));

    _defineProperty(_assertThisInitialized(_this), "minute", 60);

    _defineProperty(_assertThisInitialized(_this), "hour", 60 * _this.minute);

    _defineProperty(_assertThisInitialized(_this), "day", 24 * _this.hour);

    _defineProperty(_assertThisInitialized(_this), "timer", null);

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
      }

      var value = _this.state.value;
      var handleBlur = _this.props.handleBlur;

      var nextValue = _this.mask(value);

      _this.setState({
        value: nextValue
      }, function () {
        if (isFunction(handleBlur)) {
          handleBlur(_this.convertToInteger(value), nextValue, value);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var _this$props = _this.props,
          handleChange = _this$props.handleChange,
          maskDelay = _this$props.maskDelay;
      var _event$target$value = event.target.value,
          value = _event$target$value === void 0 ? '' : _event$target$value;

      var nextValue = _this.mask(value);

      var hasOnChangeFunction = isFunction(handleChange);
      var hasMaskDelay = isNumber(maskDelay) && maskDelay >= 0;

      if (_this.timer) {
        clearTimeout(_this.timer);
      } // Mask immediately


      if (maskDelay === 0) {
        value = nextValue;
      }

      _this.setState({
        value: value
      }, function () {
        if (hasOnChangeFunction && !hasMaskDelay) {
          handleChange(_this.convertToInteger(value), nextValue, value);
        }

        if (hasMaskDelay) {
          _this.timer = setTimeout(function () {
            return _this.handleMaskDelay(value, nextValue, hasOnChangeFunction);
          }, maskDelay);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMaskDelay", function (value, nextValue, hasOnChangeFunction) {
      var handleChange = _this.props.handleChange;

      _this.setState({
        value: nextValue
      }, function () {
        if (hasOnChangeFunction) {
          handleChange(_this.convertToInteger(value), nextValue, value);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var onKeyDown = _this.props.onKeyDown;

      if (isFunction(onKeyDown)) {
        onKeyDown(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyUp", function (event) {
      var onKeyUp = _this.props.onKeyUp;

      if (isFunction(onKeyUp)) {
        onKeyUp(event);
      }
    });

    _this.state = {
      value: _this.mask(props.value, props)
    };
    _this.ref = null;
    return _this;
  }

  _createClass(DurationInputMask, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoFocus = this.props.autoFocus;

      if (autoFocus && this.ref) {
        this.ref.focus();
      }

      this.timer = null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = this.props.value;

      if (prevProps.value !== value) {
        this.setState({
          value: this.mask(value)
        });
      }
    }
  }, {
    key: "convertToInteger",
    value: function convertToInteger() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (typeof value === 'number' || /^[0-9 ]+$/.test(value)) {
        return parseInt(value || 0, 10);
      }

      var match = value.matchAll(_wrapRegExp(/(\d*)(\w)/gi, {
        value: 1,
        unit: 2
      }));
      var volumes = {
        m: this.minute,
        h: this.hour,
        d: this.day,
        s: 1
      }; // Ensure subsequent matches of same unit are filtered out, e.g. ['2d', '1d'] => ['2d']

      var uniqueMatches = _toConsumableArray(match).reduce(function (prev, item, index) {
        if (Object.keys(prev).find(function (prevKey) {
          return prev[prevKey][2] === item[2];
        })) {
          return prev;
        }

        return _objectSpread2({}, prev, _defineProperty({}, index, item));
      }, {});

      return Object.keys(uniqueMatches).reduce(function (prev, key) {
        var unit = uniqueMatches[key][2];
        return unit.length && volumes[unit] ? prev + volumes[unit] * uniqueMatches[key][1] : prev;
      }, 0);
    }
  }, {
    key: "mask",
    value: function mask(value) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var defaultValue = props.defaultValue;
      var intValue = this.convertToInteger(value);
      var hours = intValue % this.day;
      var minutes = intValue % this.hour;
      var seconds = intValue % this.minute;
      var duration = {
        d: intValue >= this.day ? Math.floor(intValue / this.day) : 0,
        h: hours > 0 ? Math.floor(hours / this.hour) : 0,
        m: minutes > 0 ? Math.floor(minutes / this.minute) : 0,
        s: seconds
      };
      var nextValue = Object.keys(duration).reduce(function (prev, key) {
        var durationValue = duration[key];
        return durationValue ? "".concat(prev, " ").concat(durationValue).concat(key) : prev;
      }, '').trimStart();
      return nextValue || defaultValue;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var value = this.state.value;
      var ComponentProp = this.props.component;
      return React.createElement(ComponentProp, _extends({}, omit(this.props, Object.keys(propTypes)), {
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onKeyDown: this.onKeyDown,
        onKeyUp: this.onKeyUp,
        ref: function ref(_ref) {
          _this2.ref = _ref;
        },
        value: value
      }));
    }
  }]);

  return DurationInputMask;
}(PureComponent);

_defineProperty(DurationInputMask, "defaultProps", {
  autoFocus: false,
  component: 'input',
  defaultValue: '',
  maskDelay: null,
  handleBlur: null,
  handleChange: null,
  onKeyDown: null,
  onKeyUp: null,
  value: ''
});

export default DurationInputMask;
